module.exports = __webpack_public_path__ + "static/edinme-sm-c8c78b36e1d606eec8412292f512f382.jpg";